import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  UseQueryApplicationsParams,
  queryApplications,
} from "supabase/events/queryApplications";

export const useQueryApplications = (params: UseQueryApplicationsParams) => {
  const { page, perPage } = params;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ["applications", { page, perPage }],
    queryFn: () => queryApplications({ page, perPage }),
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isError,
    error,
    count: data?.count,
    applications: data?.applications,
  };
};
